<div class="row">
    <div class="col-12 mt-5 movieTemplate">
        <div class="paneles">
            <div class="row">
                <div class="col-12 px-xl-5">

                    <div class="card text-white mb-4">
                        <div class="card-body">

                            <div class="titulo">POLÍTICA DE PRIVACIDAD PARA +CINEMATECA</div>

                            <p class="texto">
                                De conformidad con las Políticas de Privacidad de Google Play y la normativa de la
                                República Oriental del Uruguay (en adelante Uruguay), vigentes en lo relativo a la
                                protección
                                de las personas físicas en lo que respecta al tratamiento de datos personales y a la
                                libre
                                circulación de estos datos, CINEMATECA URUGUAYA, informa a los usuarios de la
                                plataforma +Cinemateca (en adelante, la Plataforma), acerca del tratamiento de los datos
                                personales, que ellos voluntariamente hayan facilitado durante el proceso de registro,
                                acceso y utilización del servicio.
                            </p>

                        </div>
                    </div>

                    <div class="card text-white mb-4">
                        <div class="card-body">

                            <div class="titulo">1. IDENTIFICACIÓN DEL RESPONSABLE DEL TRATAMIENTO.</div>

                            <p class="texto">
                                CINEMATECA URUGUAYA, es la entidad responsable del tratamiento de los datos facilitados
                                por los clientes de la Plataforma (en adelante, el/los Usuario/s).
                            </p>

                        </div>
                    </div>

                    <div class="card text-white mb-4">
                        <div class="card-body">

                            <div class="titulo">2. FINALIDAD DEL TRATAMIENTO DE DATOS.</div>

                            <p class="texto">
                                Para proceder al registro, acceso y
                                posterior uso de la Plataforma, el Usuario deberá facilitar voluntariamente los datos de
                                carácter personal solicitados en el momento del registro o alta en la plataforma, tanto
                                por la
                                aplicación, cómo por página web u otros, más aquellos qué pudieran ser requeridos
                                posteriormente, los cuales serán incorporados a soportes automatizados titularidad de
                                CINEMATECA URUGUAYA. La recogida, almacenamiento, modificación, estructuración y
                                en su caso, eliminación, de los datos proporcionados por los Usuarios, constituirán
                                operaciones de tratamiento llevadas a cabo por el Responsable, con la finalidad de
                                garantizar el correcto funcionamiento de la Plataforma, mantener la relación de
                                prestación
                                de servicios y/o comercial con el Usuario, y para la gestión, administración,
                                información,
                                prestación y mejora del servicio. Todos los datos personales facilitados por el Usuario,
                                incluidos pero no limitados a datos biométricos, historial de navegación, correo
                                electrónico,
                                domicilio declarado o números telefónicos, podrán emplearse también para remitir
                                boletines
                                (newsletters), así como comunicaciones comerciales de promociones y/o publicidad de la
                                Plataforma, CINEMATECA o entidades con las qué CINEMATECA tenga convenios,
                                entendiéndose qué al momento de darse de alta en la plataforma, el Usuario haya prestado
                                previamente su consentimiento expreso para la recepción de estas comunicaciones vía
                                electrónica, telefónica o cualquier otra. Asimismo los Usuarios dejan expresa constancia
                                al
                                momento del registro qué excluyen a Cinemateca, la Plataforma y los aliados estratégicos
                                de ambas del registro “No Llame” establecido en el Decreto 132/2022.
                            </p>

                        </div>
                    </div>

                    <div class="card text-white mb-4">
                        <div class="card-body">

                            <div class="titulo">3. LEGITIMACIÓN.</div>

                            <p class="texto">
                                El suministro de los datos solicitados se hace de forma totalmente libre y
                                voluntaria por quienes deseen hacer uso de la Plataforma Cinemateca+ . El tratamiento de
                                los datos del Usuario, se realiza con las siguientes bases jurídicas que legitiman el
                                mismo: •
                                La solicitud de información y/o la contratación de los servicios de la Plataforma, se
                                encuentran amparados por la las Políticas de Privacidad de Google, cómo por la normativa
                                Uruguaya en materia de tratamiento y protección de datos personales en consonancia con
                                las cláusulas y permisos otorgados por los Usuarios al momento de su registro. • El
                                consentimiento es libre, específico, informado e inequívoco del Usuario, al poner a su
                                disposición la presente política de privacidad. Se considera a todos los efectos qué
                                existe
                                aceptación y consentimiento del Usuario de todo lo aquí informado por la acción de
                                suscripción voluntaria a la plataforma por medios, cómo, pero no limitados a, el marcado
                                de
                                una casilla dispuesta al efecto. En caso de que el Usuario no facilite a CINEMATECA sus
                                datos, o lo haga de forma errónea o incompleta, no será posible proceder al uso de la
                                Plataforma.
                            </p>

                        </div>
                    </div>

                    <div class="card text-white mb-4">
                        <div class="card-body">

                            <div class="titulo">4. CONSERVACIÓN DE LOS DATOS PERSONALES.</div>

                            <p class="texto">
                                Los datos personales proporcionados
                                por el Usuario para el uso de la Plataforma, se conservarán en los sistemas y bases de

                                datos del Responsable del Tratamiento, mientras aquél continúe haciendo uso de la
                                Plataforma, y siempre que no solicite su supresión. Con el objetivo de depurar las
                                posibles
                                responsabilidades derivadas del tratamiento, los datos se conservarán por un período
                                mínimo de diez años.
                            </p>

                        </div>
                    </div>

                    <div class="card text-white mb-4">
                        <div class="card-body">

                            <div class="titulo">5. DESTINATARIOS.</div>

                            <p class="texto">
                                Los datos no se comunicarán a ningún tercero
                                con quien CINEMATECA no tenga una vinculación directa, salvo obligación legal u orden
                                judicial de las autoridades uruguayas competentes. De otra parte, CINEMATECA podrá dar
                                acceso o transmitir los datos personales facilitados o el registro de navegación del
                                Usuario,
                                a terceros proveedores de servicios, con los que haya suscrito acuerdos de encargo de
                                tratamiento de datos, y que únicamente accedan a dicha información para prestar un
                                servicio en favor y por cuenta del Responsable.
                            </p>

                        </div>
                    </div>

                </div>
            </div>
        </div>
    </div>
</div>